import React, { useEffect, useContext, useState, useMemo } from "react";
import {
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from "@coreui/react";
import api from "../services/config.url";
import showPopup from "../components/PopUp";
import AuthContext from "../contexts/auth";
import { saveAs } from 'file-saver';

const MyEbooks = (props) => {
    const { cart, setLoading, setSizeCart, user } = useContext(AuthContext);
    const [orders, setOrders] = useState([]);
    const sizeCart = useMemo(() => cart?.items?.length, [cart]);
    const [isLoadingContainer, setIsLoadingContainer] = useState(false);

    useEffect(() => {
      if (!cart) return;
      setSizeCart(sizeCart);
      setIsLoadingContainer(true);
      const fetchData = async () => {
        try {
          const response = await api.get(
            `/customers/orders/customer-ebooks`
          );
          console.log('E-books response:', response.data)
          setOrders(response.data);
        } catch (error) {
          const BackendError = error?.response?.data?.message;
          const genericError = "Erro ao listar os E-books";
          showPopup(BackendError || genericError, "error");
        } finally {
          setIsLoadingContainer(false);
        }
      };
      fetchData();
    }, [cart]);
  
    const handleDownloadCloud = async (obj) => {
        const sku = obj?.items?.product?.sku || obj?.sku || obj?.parent?.sku;
        const { name, secondName, document: documentCustomer } = user || {};
  
      if (!name) {
        showPopup(
          "O campo Nome é obrigatório! Acesse seu perfil para preenchê-lo.",
          "error"
        );
        return;
      }
      if (!secondName) {
        showPopup(
          "O campo Sobrenome é obrigatório! Acesse seu perfil para preenchê-lo.",
          "error"
        );
        return;
      }
      if (!documentCustomer) {
        showPopup(
          "O campo CPF é obrigatório! Acesse seu perfil para preenchê-lo.",
          "error"
        );
        return;
      }
      try {
        setLoading(true);
        const response = await api.post(
          `/customers/products/cloud-pdf`,
          {
            sku,
            customerName: `${name} ${secondName}`,
            customerCPF: documentCustomer,
          },
          { "Content-Type": "application/pdf" }
        );
        const pdfUrl = response.data.downloadUrl;
        fetch(pdfUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Erro ao baixar o arquivo");
            }
            return response.blob();
          })
          .then((blob) => {
            saveAs(blob, `${response.data.fileName}.pdf`);
          })
          .catch((error) => {
            console.error("Erro:", error);
          });
      } catch (error) {
        const BackendError = error?.response?.data?.message;
        const genericError = "Erro ao baixar os arquivos";
        showPopup(BackendError || genericError, "error");
      } finally {
        setLoading(false);
      }
    };


  return (
    <>
   <CAccordion>
        <CAccordionItem itemKey={1}>
          <div className="table-responsive">
            <div className="table check-tbl">
              <CAccordionHeader className="bg-my-books-collapse">
                <div className="title-of-table ">
                  <div>MEUS E-BOOKS</div>
                </div>
              </CAccordionHeader>
              <CAccordionBody className="p-0">
                <div className="lines-of-table">
                  {orders && orders?.length < 1 ? (
                    !isLoadingContainer ? (
                      <div className="p-3">
                        Você não possui nenhum E-book com status de pagamento
                        aprovado.
                      </div>
                    ) : (
                      <div className="loadingContainer m-3"></div>
                    )
                  ) : (
                    <div>
                      {orders?.map((order, index) => (
                        <div key={index} className="p-3 flex-my-books" style={{ borderBottom: '1px solid #eee' }}>
                          <div className="d-flex justify-content-between w-100 align-items-center">
                            <div>
                              <div style={{ marginBottom: "5px", fontWeight: "500" }}>
                                {order?.items?.product?.sku && `${order?.items?.product?.sku} - `}
                                {order?.items?.product?.name || 'E-book sem nome'}
                              </div>
                              {order?.expiryDate && (
                                <div style={{ fontSize: "12px", color: "#666" }}>
                                  Expira em: {new Date(order?.expiryDate).toLocaleDateString('pt-BR')}
                                </div>
                              )}
                            </div>
                         
                          </div>
                             <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                              <input
                                type="button"
                                onClick={() => handleDownloadCloud(order)}
                                className="btn btn-primary btnhover"
                                style={{ padding: "5px 15px", fontSize: "14px" }}
                                value={"Download"}
                              />
                            
                            </div>
                        </div>
                        
                      ))}
                    </div>
                  )}
                </div>
              </CAccordionBody>
            </div>
            <div></div>
          </div>
        </CAccordionItem>
      </CAccordion>
    </>
  );
};

export default MyEbooks;
